export function formatPrice(amount: number) {
	return new Intl.NumberFormat('es-MX', {
		style: 'currency',
		currency: 'MXN',
		maximumFractionDigits: 2
	}).format(amount);
}
